<section class="main-section h-100 d-flex align-items-center justify-content-center">
    <div>
        <ng-container *ngIf="isPage">
            <div class="custom-icon-wrapper">
                <i class=" icon-edponline-Bra-109 custom-icon"></i>
            </div>
        </ng-container>
        <div class="section-description-wrapper">
            <p class="section-description">{{ "pt.edp.edponline.eligibility.analysis.page.description" | translate }}</p>
        </div>
        <div *ngIf="agreementEligibility?.debits?.length > 1" class="section-choose-description-wrapper">
            <p class="section-choose-description">{{ "pt.edp.edponline.eligibility.analysis.choose.description" | translate }}</p>
        </div>
        <ng-container *ngFor="let debit of agreementEligibility?.debits; let idx = index">
            <div
                class="eligibility-card d-block d-md-flex"
                [ngClass]="{ selected: idx === selectedIndex }"
                (click)="selectCard(idx, debit.accountNumber)"
            >
                <div class="w-100 w-md-50">
                    <p class="eligibility-card-name-label">{{ debit.name }}</p>
                    <p class="eligibility-card-address-label">
                        {{ debit.address.street }}, {{ debit.address.houseNumber }}, {{ debit.address.postalCode }}
                        {{ debit.address.city }}
                    </p>
                </div>
                <div class="w-100 w-md-50">
                    <div class="eligibility-card-total-debit-wrapper">
                        <p class="eligibility-card-total-debit">
                            Valor total do acordo:
                            <span class="eligibility-card-total-debit-bold">{{ debit.value }}€</span>
                        </p>
                    </div>
                    <div class="eligibility-card-invoices-wrapper">
                        <div>
                            <p class="eligibility-card-label">
                                {{ "pt.edp.edponline.eligibility.analysis.card.label.invoice" | translate }}
                            </p>
                            <div class="d-flex flex-wrap">
                                <ng-container *ngFor="let month of debit?.months; let i = index">
                                    <div [ngClass]="{ pr: isEven(i), pl: !isEven(i) }">
                                        <p class="eligibility-card-value">
                                            {{ month.month | date: "MMM yyyy" | titlecase }}
                                            <span class="eligibility-card-value-bold">{{ month.amount }}€</span>
                                        </p>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="debit.pp !== '0.00'" class="eligibility-card-debit-wrapper">
                            <p class="eligibility-card-label">
                                {{ "pt.edp.edponline.eligibility.analysis.card.label.debit.payment.plan" | translate }}
                            </p>
                            <div class="d-flex">
                                <p class="eligibility-card-value mr-4">
                                    <span class="eligibility-card-value-bold">#{{ debit.ppDocNumber }}</span>
                                </p>
                                <p class="eligibility-card-value">
                                    <span class="eligibility-card-value-bold">{{ debit.pp }}€</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!isPage">
            <div class="custom-button-wrapper">
                <button
                    class="custom-button"
                    (click)="onAgreementGenerate(captchaRef)"
                    [disabled]="selectedIndex === null"
                    [ngClass]="{ disabled: selectedIndex === null }"
                >
                    {{ "pt.edp.edponline.eligibility.analysis.button.label" | translate }}
                </button>
            </div>
        </ng-container>
    </div>
</section>
<ng-container *ngIf="isPage">
    <div class="eligibility-bottom-bar-wrapper">
        <div class="eligibility-bottom-bar-wrapper-inner">
            <button
                class="custom-button"
                (click)="onAgreementGenerate(captchaRef)"
                [disabled]="selectedIndex === null"
                [ngClass]="{ disabled: selectedIndex === null }"
            >
                {{ "pt.edp.edponline.eligibility.bottom.bar.button.label" | translate }}
            </button>
        </div>
    </div>
</ng-container>
<div class="recaptcha-wrapper">
    <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
</div>
